// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "v1.3.0-85-ge8912cc-dirty",
    "hash": "ge8912cc",
    "distance": 85,
    "tag": "v1.3.0",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "v1.3.0",
        "major": 1,
        "minor": 3,
        "patch": 0,
        "prerelease": [],
        "build": [],
        "version": "1.3.0"
    },
    "suffix": "85-ge8912cc-dirty",
    "semverString": "1.3.0+85.ge8912cc",
    "version": "2.5.0"
};
/* tslint:enable */
